module.exports = __webpack_public_path__ + "static/media/blogThumbnail.3c56c562.jpeg";